module.exports = __webpack_public_path__ + "img/ichkoche2022.73f73f37.svg";